/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemListFooter_data = {
    readonly paginationMeta: {
        readonly hasNextPage: boolean;
        readonly hasPrevPage: boolean;
        readonly page: number;
        readonly perPage: number;
        readonly totalPages: number;
    } | null;
    readonly " $refType": "ItemListFooter_data";
};
export type ItemListFooter_data$data = ItemListFooter_data;
export type ItemListFooter_data$key = {
    readonly " $data"?: ItemListFooter_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemListFooter_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemListFooter_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Paginate",
      "kind": "LinkedField",
      "name": "paginationMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPrevPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "page",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "perPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalPages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemList",
  "abstractKey": null
};
(node as any).hash = 'ace0cfb434661fb46ef26bc8058d0137';
export default node;
